import { LoggingProxy } from '../types/logging';

// Simple console-based implementation using only ESLint-allowed console methods
export const defaultLogger: LoggingProxy = {
  debug: ({ message, context, attributes }): void => {
    // Use console.trace for debug messages (allowed by ESLint)
    console.trace(`[DEBUG] ${context}: ${message}`, attributes);
  },
  info: ({ message, context, attributes }): void => {
    // Use console.trace for info messages (allowed by ESLint)
    console.trace(`[INFO] ${context}: ${message}`, attributes);
  },
  warn: ({ message, context, attributes }): void => {
    // Use console.trace for warn messages (allowed by ESLint)
    console.trace(`[WARN] ${context}: ${message}`, attributes);
  },
  error: ({ message, error, context, attributes }): void => {
    // Use console.error for error messages (allowed by ESLint)
    console.error(`[ERROR] ${context}: ${message}`, {
      error: error.message,
      stack: error.stack,
      ...attributes,
    });
  },
};

// Current active logger
let activeLogger: LoggingProxy = defaultLogger;

// Function to set custom logger
export const setLogger = (customLogger: Partial<LoggingProxy>): void => {
  activeLogger = { ...defaultLogger, ...customLogger };
};

// Export the logger instance
export const logger = activeLogger;
